<template>
    <table class="inspections-table">
        <thead>
            <tr>
                <th>Год</th>
                <th colspan="2">Плановые<br>(нарушения)</th>
                <th colspan="2">Внеплановые<br>(нарушения)</th>
                <th colspan="2">Всего<br>(нарушения)</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(y, i) in years" :key="i">
                <td class="first-column"><button @click="getByYear(y)" class="btn blue-red-hover-text">{{ y }}</button></td>

                <td class="right">{{ data[y].plan.amount }}</td>
                <td class="left">({{ data[y].plan.violations }})</td>

                <td class="right">{{ data[y].notplan.amount }}</td>
                <td class="left">({{ data[y].notplan.violations }})</td>

                <td class="right">{{ data[y].plan.amount + data[y].notplan.amount }}</td>
                <td class="left">({{ data[y].plan.violations + data[y].notplan.violations }})</td>
            </tr>
            <tr class="last-row">
                <td class="first-column"><button @click="getByYear('')" class="btn italic blue-red-hover-text">Все годы</button></td>

                <td class="right">{{ data.total.plan.amount }}</td>
                <td class="left">({{ data.total.plan.violations }})</td>

                <td class="right"> {{ data.total.notplan.amount }}</td>
                <td class="left">({{ data.total.notplan.violations }})</td>

                <td class="right">{{ data.total.plan.amount + data.total.notplan.amount }}</td>
                <td class="left">({{ data.total.plan.violations + data.total.notplan.violations }})</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        years: Array,
        data: Object
    },
    methods: {
        getByYear(year, offset = 0, limit = 50) {
            this.$store.dispatch('card/inspections/getInspectionsByYear', { year, offset, limit })
        }
    },
    mounted() { $('tiles').trigger('resize') }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.inspections-table
    @include lic-table()
    font-size: 13px
    tr
        th
            text-align: center
            vertical-align: baseline
        td.left
            text-align: left !important
        td.right
            text-align: right !important
        td.first-column
            text-align: left !important
            width: 1%
            white-space: nowrap
        td
            font-size: 13px !important
            width: 15%
            .btn
                background: none
    tr.last-row
        &:hover
            background: none
        td
            border-top: 1px solid #ddd
            font-weight: 700
            .italic
                font-weight: 700
                font-style: italic
</style>